import SelectableGridRowWrapper from 'components/SelectableGrid/components/SelectableGridRowWrapper';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const SelectableGridHeader: FunctionComponent<Props> = ({ children, ref, testId = TEST_ID }) => (
    <SelectableGridRowWrapper ref={ref} testId={testId}>
        {children}
    </SelectableGridRowWrapper>
);

export default SelectableGridHeader;
